module.exports = __webpack_public_path__ + "media/images/humana-logo-fa78bc7e0ca220c4eb0dc28f71a8a6be.jpg";